import { Textarea } from '@ntconsult/aluma-react';

const selecionar = (el: HTMLTextAreaElement | null) => el?.select();

/** Área de transferência recusada: o texto já selecionado, para Ctrl+C (spec 31 R7). */
export function TextoParaCopiar({ texto, rotulo }: { texto: string; rotulo: string }) {
  return (
    <Textarea
      readOnly
      ref={selecionar}
      value={texto}
      aria-label={rotulo}
      rows={Math.min(4, texto.split('\n').length + 1)}
      className="font-mono text-sm"
    />
  );
}
